// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__zZHvI","scrollable":"breadcrumb_scrollable__gWi4I"};